import React, { useEffect } from "react";
import styles from "./ProductBanner.module.css";
import PreLoader from "../../../components/PreLoader/PreLoader";
import SimpleBtn from "../../../components/Button/SimpleBtn";
import { handleCall } from "../../../utils/callHelper";

import { style } from "framer-motion/client";

const ProductBanner = ({ product }) => {
  if (!product) return <PreLoader />;
  const { name, title, img, subtitle } = product;

  return (
    <>
      <div className={`${styles.ProductBanner}`}>
        <div className={`${styles.bannerContent}`}>
          <h1 className={`${styles.bannerTitle}`}>{title}</h1>
          <h2 className={`${styles.bannerSubtitle}`}>{subtitle}</h2>
          <SimpleBtn className={`${styles.bannerButton}`} onClick={handleCall}>
            مشاوره و خرید مستقیم: 09216388036
          </SimpleBtn>
        </div>
        <img
          src={`${img}`}
          alt={`عکس محصول ${name}`}
          className={`${styles.bannerImg}`}
        />
      </div>
    </>
  );
};

export default ProductBanner;
